import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import ThemeThreeTitle from '../common/ThemeThreeTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ArzolaFlota = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	return (
		<div>
			<KuposHelmet />

			<HeroSection
				heroImage={getIcons('flotaBanner', operator)}
				title="Flota"
				description="Home / Flota"
				height={'45vh'}
			/>
			<div className='new-container'>
				<ThemeThreeTitle operator={operator} title="Equipamento" />

				<img src="assets/arzola/icons/flota-icons.svg" />
			</div>
		</div>
	)
}

export default ArzolaFlota


// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/arzola/ArzolaFlota.js